@if (otpForm?.controls) {
  <div class="wrapper {{config.containerClass}}" id="c_{{componentKey}}"
    [ngStyle]="config.containerStyles">
    @for (item of otpForm?.controls | keys; track item; let i = $index) {
      <input [pattern]="config.allowNumbersOnly ? '^[0-9]$' : ''" inputmode="numeric" [type]="config.inputType ? config.inputType : inputType" numbersOnly [placeholder]="config?.placeholder || ''"
        [ngStyle]="config.inputStyles" maxlength="1" [ngClass]="{ 'is-invalid': otpForm.controls[item].errors }"
        class="otp-input {{config.inputClass}}" autocomplete="one-time-code" (input)="onInput($event)"
        [formControl]="otpForm.controls[item]" id="otp_{{i}}_{{componentKey}}" (keydown)="onKeyDown($event)"
        (keyup)="onKeyUp($event,i)">
    }
  </div>
}